import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/folders.action'
import destroyFolder from 'api/administration/folders/Destroy'
import foldersList from 'api/administration/folders/List'
import I18n from '../../../i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'

async function getList() {
  return await foldersList()
}

async function handleDestroy(folderId: number) {
  return await destroyFolder(folderId)
}

function* destroyFolderEffectSaga(action: any) {
  try {
    // FIRST DELETE THE FOLDER
    const { id } = action.payload

    yield call(handleDestroy, id)

    // SECOND RELOAD DATA
    const { data } = yield call(getList)
    yield put(fromActions.Actions.foldersAdministrationListSuccess(data))

    SuccessToast(I18n.t('administration.toastMessages.folderDeleteSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.folderDeleteError'))
    console.log('error: ', error)
  }
}

export function* destroyFolderWatcherSaga() {
  yield takeLatest(fromActions.DESTROY_FOLDER, destroyFolderEffectSaga)
}
